var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#pin-temporary';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-pin-temporary';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?pin-temporary#pin-temporary';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?pin-temporary#view-pin-temporary';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 9 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };